import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class AccountService {
  DoGetAllMainAccount() {
    return service.peakRealTimeAPI
      .post("/api/Account/GetAllAccountByMerchantId", {}, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new AccountService();
